<template lang="html">
    <div>
        <p class="text-xs-center">Êtes-vous sûr de vouloir supprimer les {{$store.state.datatable.tests.selected.length }} contrôles selectionnés</p>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                title:          'Suppression de contrôles',
                icon:           'delete',
                warning:        true
            }
        },

        methods: {
            onClose() {
                this.$eventHub.$emit('close-modal')
            },

            onValidate() {
                this.$store.state.datatable.tests.selected.forEach((item, index) => {
                    this.axios.delete(`/api/tests/${item.id}`)
                        .then(response => {
                            this.$eventHub.$emit('close-modal')
                            this.$eventHub.$emit('reload-list')
                            this.$store.dispatch('updateSingleData', { key:'tests_count', value:this.$store.state.single.data.tests_count - this.$store.state.datatable.tests.selected.length})
                        })
                        .catch(err => console.log(err.response.data))
                })
            }
        }
    }
</script>

<style lang="stylus" scoped>
    div {
        padding: 1rem 4rem

        ul {
            margin-left: 3rem
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/products/single/DeleteTest.vue